<mat-card class="">
  <mat-card-header class="titreFrm">
    <mat-card-title>RESSOURCES MAT&Eacute;RIELLES</mat-card-title>
  </mat-card-header>
  <mat-card-content class="border">
    <div *ngIf="exist; else attente"></div>
    <ng-template #attente>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </ng-template>
    <form class="example-form" #form="ngForm">
      <!---------------------- bouton ------------------------->
      <div class="btn">
        <!-- <div class="button-row">
                    <button *ngIf="!disabled" [disabled]="!exist || disabled" (click)="goToListeMachine()" mat-raised-button class="colorGreen">
                        <mat-icon>format_list_bulleted</mat-icon>
                        Liste des ressources matérielles
                    </button>
                </div> -->
        <div class="button-row">
          <button
            *ngIf="!disabled"
            [disabled]="!exist || disabled"
            (click)="enregistrer(form)"
            mat-raised-button
            class="colorGreen"
          >
            <mat-icon>save</mat-icon>
            Enregistrer
          </button>
        </div>
      </div>
      <mat-tab-group
        [selectedIndex]="index"
        (animationDone)="tabChanged()"
        (selectedIndexChange)="index = $event"
      >
        <!------------------- Véhicules & Équipements ------------------------------>
        <mat-tab label="Véhicules & Équipements">
          <div>
            <mat-card style="margin: 20px 20px 0 20px" class="">
              <mat-card-content>
                <mat-radio-group
                  [disabled]="disabled"
                  name="Machine_Type"
                  [(ngModel)]="machine.Machine_Type"
                >
                  <mat-radio-button
                    *ngFor="let type of listeMachine_Type"
                    [value]="type.value"
                    >{{ type.text }}</mat-radio-button
                  >
                </mat-radio-group>
              </mat-card-content>
            </mat-card>
            <!--------------- Véhicules ---------------------->
            <div class="displayFlex">
              <mat-card class="carClass">
                <h5>Affecter à un collaborateur</h5>
                <!-- <mat-form-field     appearance="outline"  class="width-180">
                                        <mat-label>Collaborateurs</mat-label>
                                        <mat-select placeholder="Collaborateurs" name="xx" [(ngModel)]="machine.Perso_Matricule">
                                            <mat-option *ngFor="let Perso of listeCollaborateurs" [(value)]="Perso.Perso_Matricule">{{Perso.Perso_Nom + " " + Perso.Perso_Prenom}}</mat-option>
                                        </mat-select>
                                    </mat-form-field> -->

                <app-recherche
                  #collaborateurComponent
                  [style]="{ width: '180px' }"
                  [disabled]="disabled"
                  [api]="generalService.api"
                  [numColonneToShow]="1"
                  [numColonneToReturn]="0"
                  recherche="avtAcollaborateur"
                  [param]="'0'"
                  name="name_2"
                  placeholder="Collaborateur"
                  (ChampEnter)="blurCollaborateur($event)"
                >
                </app-recherche>
              </mat-card>
              <mat-card class="carClass" *ngIf="machine.Machine_Type == 1">
                <mat-card-content>
                  <h5>Véhicules</h5>
                  <mat-form-field appearance="outline">
                    <mat-label>Marque</mat-label>
                    <input
                      matInput
                      [disabled]="disabled"
                      name="Machine_CapUnite"
                      #Machine_CapUnite="ngModel"
                      [(ngModel)]="machine.Machine_CapUnite"
                      placeholder="Marque"
                      required
                    />
                  </mat-form-field>
                  <mat-form-field appearance="outline" style="width: 200px">
                    <mat-label>Num plaque d'immatriculation</mat-label>
                    <input
                      matInput
                      [disabled]="disabled"
                      name="Machine_Serie"
                      #Machine_Serie="ngModel"
                      [(ngModel)]="machine.Machine_Serie"
                      placeholder="Num plaque d'immatriculation"
                      required
                    />
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-select
                      [disabled]="disabled"
                      name="Machine_CH"
                      #Machine_CH="ngModel"
                      [(ngModel)]="machine.Machine_CH"
                      placeholder="Carburant"
                      required
                    >
                      <mat-option
                        *ngFor="let carburant of listeTypeCarburant"
                        [value]="carburant.DiverSys_Index"
                        >{{ carburant.DiverSys_Titre }}</mat-option
                      >
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="outline" style="width: 200px">
                    <mat-label>Référence interne</mat-label>
                    <input
                      matInput
                      [disabled]="disabled"
                      name="Machine_Lib"
                      #Machine_Lib="ngModel"
                      [(ngModel)]="machine.Machine_Lib"
                      placeholder="Référence interne"
                      required
                    />
                  </mat-form-field>
                  <mat-form-field appearance="outline" style="width: 90px">
                    <mat-label>Nbr place</mat-label>
                    <input
                      matInput
                      [disabled]="disabled"
                      min="0"
                      name="Machine_Nbre"
                      #Machine_Nbre="ngModel"
                      [(ngModel)]="machine.Machine_Nbre"
                      type="number"
                      placeholder="Nbr place"
                      required
                    />
                  </mat-form-field>
                </mat-card-content>
              </mat-card>
              <!------------------ équipement multimédia -------------------->
              <mat-card class="carClass" *ngIf="machine.Machine_Type == 2">
                <mat-card-content>
                  <h5>&Eacute;quipement multimédia</h5>
                  <mat-form-field appearance="outline">
                    <mat-label>Type équipement</mat-label>
                    <mat-select
                      [disabled]="disabled"
                      name="Machine_CH"
                      #Machine_CH="ngModel"
                      [(ngModel)]="machine.Machine_CH"
                      placeholder="Type équipement"
                      required
                    >
                      <mat-option
                        *ngFor="let salle of listeMAchineMultimedia"
                        [value]="salle.DiverSys_Index"
                      >
                        {{ salle.DiverSys_Titre }}</mat-option
                      >
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="outline" style="width: 200px">
                    <mat-label>Num série</mat-label>
                    <input
                      matInput
                      [disabled]="disabled"
                      name="Machine_Serie"
                      #Machine_Serie="ngModel"
                      [(ngModel)]="machine.Machine_Serie"
                      placeholder="Num série"
                      required
                    />
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Type salle</mat-label>
                    <mat-select
                      [disabled]="disabled"
                      name="Machine_Compteur"
                      #Machine_Compteur="ngModel"
                      [(ngModel)]="machine.Machine_Compteur"
                      placeholder="Type salle"
                      required
                    >
                      <mat-option
                        *ngFor="let salle of listeAllSalle"
                        [value]="salle.DiverSys_Index"
                      >
                        {{ salle.DiverSys_Titre }}</mat-option
                      >
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="outline" style="width: 200px">
                    <mat-label>Référence interne</mat-label>
                    <input
                      matInput
                      [disabled]="disabled"
                      name="Machine_Lib"
                      #Machine_Lib="ngModel"
                      [(ngModel)]="machine.Machine_Lib"
                      placeholder="Référence interne"
                      required
                    />
                  </mat-form-field>
                </mat-card-content>
              </mat-card>
              <!--------------------------- equipement industriel---------------------- -->
              <mat-card class="carClass" *ngIf="machine.Machine_Type == 3">
                <mat-card-content>
                  <h5>&Eacute;quipements industriels</h5>
                  <mat-form-field appearance="outline">
                    <mat-label>Type équipement</mat-label>
                    <mat-select
                      [disabled]="disabled"
                      name="Machine_CH"
                      #Machine_CH="ngModel"
                      [(ngModel)]="machine.Machine_CH"
                      placeholder="Type équipement"
                      required
                    >
                      <mat-option
                        *ngFor="let salle of listeMAchineIndustriels"
                        [value]="salle.DiverSys_Index"
                      >
                        {{ salle.DiverSys_Titre }}</mat-option
                      >
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="outline" style="width: 200px">
                    <input
                      matInput
                      [disabled]="disabled"
                      name="Machine_Serie"
                      #Machine_Serie="ngModel"
                      [(ngModel)]="machine.Machine_Serie"
                      placeholder="Num série"
                      required
                    />
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Type salle</mat-label>
                    <mat-select
                      [disabled]="disabled"
                      name="Machine_Compteur"
                      #Machine_Compteur="ngModel"
                      [(ngModel)]="machine.Machine_Compteur"
                      placeholder="Type salle"
                      required
                    >
                      <mat-option
                        *ngFor="let salle of listeAllSalle"
                        [value]="salle.DiverSys_Index"
                      >
                        {{ salle.DiverSys_Titre }}</mat-option
                      >
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="outline" style="width: 200px">
                    <mat-label>Référence interne</mat-label>
                    <input
                      matInput
                      [disabled]="disabled"
                      name="Machine_Lib"
                      #Machine_Lib="ngModel"
                      [(ngModel)]="machine.Machine_Lib"
                      placeholder="Référence interne"
                      required
                    />
                  </mat-form-field>
                </mat-card-content>
              </mat-card>
              <!-------------------- equipements BTP---------------- -->
              <mat-card class="carClass" *ngIf="machine.Machine_Type == 4">
                <mat-card-content>
                  <h5>&Eacute;quipements BTP</h5>
                  <mat-form-field appearance="outline">
                    <mat-label>Type équipement</mat-label>
                    <mat-select
                      [disabled]="disabled"
                      name="Machine_CH"
                      #Machine_CH="ngModel"
                      [(ngModel)]="machine.Machine_CH"
                      placeholder="Type équipement"
                      required
                    >
                      <mat-option
                        *ngFor="let salle of listeMAchineBTP"
                        [value]="salle.DiverSys_Index"
                      >
                        {{ salle.DiverSys_Titre }}</mat-option
                      >
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="outline" style="width: 200px">
                    <mat-label>Num série</mat-label>
                    <input
                      matInput
                      [disabled]="disabled"
                      name="Machine_Serie"
                      #Machine_Serie="ngModel"
                      [(ngModel)]="machine.Machine_Serie"
                      placeholder="Num série"
                      required
                    />
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Type salle</mat-label>
                    <mat-select
                      [disabled]="disabled"
                      name="Machine_Compteur"
                      #Machine_Compteur="ngModel"
                      [(ngModel)]="machine.Machine_Compteur"
                      placeholder="Type salle"
                      required
                    >
                      <mat-option
                        *ngFor="let salle of listeAllSalle"
                        [value]="salle.DiverSys_Index"
                      >
                        {{ salle.DiverSys_Titre }}</mat-option
                      >
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="outline" style="width: 200px">
                    <mat-label>Référence interne</mat-label>
                    <input
                      matInput
                      [disabled]="disabled"
                      name="Machine_Lib"
                      #Machine_Lib="ngModel"
                      [(ngModel)]="machine.Machine_Lib"
                      placeholder="Référence interne"
                      required
                    />
                  </mat-form-field>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
        </mat-tab>
        <!------------------- Commentaires ------------------------------>
        <mat-tab [disabled]="typeTrs == '1'" label="Commentaires">
          <!-- Angular Editor Supprimer -->
          <!-- <angular-editor [config]="editorConfig" name="MachineCommentaires" placeholder=" " #Machine_Commentaires="ngModel" [(ngModel)]="machine.Machine_Commentaires"></angular-editor> -->
        </mat-tab>
        <mat-tab [disabled]="typeTrs == '1'" label="Documents">
          <div *ngIf="showDoc">
            <app-show-tree-doc
              [param_code]="machine.Machine_Code"
              [File_Type]="'machine'"
              [typeTrs]="typeTrs"
            >
            </app-show-tree-doc>
          </div>
        </mat-tab>
      </mat-tab-group>
    </form>
  </mat-card-content>
</mat-card>
